import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <p>{t("footerRights")}</p>
    </footer>
  );
};

export default Footer;
